module.exports = __webpack_public_path__ + "static/media/S2CS-A.ba289b9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S2CS-A.jpg
// module id = 87
// module chunks = 0